<ihd-dialog-title [innerHTML]="config.title | translate: config.titleParams" class="mt-3"></ihd-dialog-title>
<ihd-dialog-body>
    <button ihdIconButton icon="close" class="c-icon-btn--sm x-close-confirm-dialog-icon-button" ihdDialogClose></button>
    <div [innerHTML]="config.content | translate: config.contentParams"></div>
    <div class="text-left" *ngIf="config.items && config.items.length">
        <hr>
        <ul class="list-unstyled">
            <li *ngFor="let item of config.items">
                <div class="ihd-circle-danger">
                    <i class="icon-close"></i>
                </div>
                <span [innerHTML]="item | translate"></span>
            </li>
        </ul>
        <hr>
    </div>
    <div *ngIf="config?.optionalMessage" class="mt-4">
        <textarea class="c-form-control c-dialog__optional-message"
                  placeholder="{{ 'Common.OptionalMessage' | translate }}"
                  ihdAutoFocus
                  [(ngModel)]="optionalMessage" rows="2"
                  maxlength="{{ config?.optionalMessageMaxLength > 0 ? config?.optionalMessageMaxLength : null }}"></textarea>
        <div *ngIf="config?.optionalMessageMaxLength > 0" class="mt-2 d-flex justify-content-end">
            <span
                class="c-label--muted">{{ 'Common.MaxCharacters' | translate: {count: config?.optionalMessageMaxLength} }}</span>
        </div>
    </div>
</ihd-dialog-body>
<ihd-dialog-actions>
    <ihd-button-group class="c-btn-group--column">
        <button ihdButton type="button"
                class="c-btn--block c-btn--lg mb-5 {{confirmBtnModifierClass}}"
                [disabled]="isClosing"
                [ihdDialogClose]="config?.optionalMessage ? { confirmed: true, message: optionalMessage } : true">
            {{ confirmText | translate }}
        </button>

        <button ihdButton type="button"
                class="c-btn--link-primary c-btn--block c-btn--lg"
                ihdDialogClose
                *ngIf="!config?.hideCancelButton"
                [disabled]="isClosing">
            {{ cancelText | translate }}
        </button>
    </ihd-button-group>
</ihd-dialog-actions>
